var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeComponent == "default"
        ? [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "form-group col-md-3" }, [
                _c("div", { staticClass: "form-check form-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.showShadow,
                        expression: "showShadow"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "flexCheckDefault" },
                    domProps: {
                      checked: Array.isArray(_vm.showShadow)
                        ? _vm._i(_vm.showShadow, null) > -1
                        : _vm.showShadow
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.showShadow,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.showShadow = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.showShadow = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.showShadow = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "flexCheckDefault" }
                    },
                    [_vm._v("\n            Show Shadow\n          ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-3" }, [
                _c("div", { staticClass: "form-check form-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.showSkeleton,
                        expression: "showSkeleton"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "showSkeleton" },
                    domProps: {
                      checked: Array.isArray(_vm.showSkeleton)
                        ? _vm._i(_vm.showSkeleton, null) > -1
                        : _vm.showSkeleton
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.showSkeleton,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.showSkeleton = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.showSkeleton = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.showSkeleton = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "showSkeleton" }
                    },
                    [_vm._v("\n            Show Skeleton\n          ")]
                  )
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "modelsinspector"
        ? _c("models-inspector")
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "characterinspector"
        ? _c("character-inspector")
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "soundinspector"
        ? _c("sound-inspector")
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "imagesinspector"
        ? _c("images-inspector")
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "videosinspector"
        ? _c("videos-inspector")
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "lightsinspector"
        ? _c("lights-inspector")
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "effectsinspector"
        ? _c("effects-inspector")
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "experienceinspector"
        ? _c("experience-inspector")
        : _vm._e(),
      _vm._v(" "),
      _vm.activeComponent == "placeholderinspector"
        ? _c("placeholder-inspector")
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cecb915", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cecb915","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector.vue
// module id = null
// module chunks = 